import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { cntProps } from 'vue/applications/frontend/mixins/cnt-component';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'cnt-error_code',
  props: {...cntProps()},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("pre", null, "      " + _toDisplayString(_ctx.contentItem.widget_data.error_code) + "\n    ", 1))
}
}

})